import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Martina R.',
  role: 'Docente Scuola Superiore',
  location: 'Milano',
  quote: 'Un salvavita assoluto. Le mappe concettuali sono perfette per i miei studenti con DSA, e i laboratori guidati mi hanno fatto risparmiare ore di ricerca. Lezioni molto più moderne e coinvolgenti.',
  initials: 'MR',
  color: '#1E8E5A'
}, {
  name: 'Luca T.',
  role: 'Docente Scuola Media',
  location: 'Roma',
  quote: 'Insegno da 10 anni e non avevo mai trovato un sistema così ben organizzato. Le verifiche già pronte e divise per livello sono una manna dal cielo. Gli studenti sono molto più attenti.',
  initials: 'LT',
  color: '#5CCB7F'
}, {
  name: 'Federica C.',
  role: 'Docente di Scienze',
  location: 'Torino',
  quote: 'Ho recuperato i miei weekend. Prima passavo le domeniche a creare slide e cercare immagini di cellule e anatomia. Ora apro il kit e ho tutto pronto. Consigliatissimo a tutti i colleghi.',
  initials: 'FC',
  color: '#1E8E5A'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-243">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/5 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-244"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-245">
        <div className="text-center mb-10 sm:mb-14" data-id="element-246">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-247">
            ⭐ Testimonianze Reali
          </p>
          <h2 className="text-3xl sm:text-5xl font-montserrat font-black text-text-main mb-4 tracking-tight" data-id="element-248">
            Cosa dicono i docenti <span className="text-primary" data-id="element-249">italiani</span>
            .
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-250">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-251">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-252">
              4.9/5 (+1.200 Recensioni Verificate)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-253">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(30,142,90,0.15)] flex flex-col relative" data-id="element-254">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/10 leading-none select-none" data-id="element-255">
                "
              </span>

              <div className="text-[#E0A52E] text-sm mb-3" data-id="element-256">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-257">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-258">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-259">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-260">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-261">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-262">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-263">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}